import { useState } from "react";
import { toast } from "sonner";
import { Phone, Mail, MapPin, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function Contact() {
  const [form, setForm] = useState({ full_name: "", email: "", phone: "", subject: "Demande générale", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message envoyé. À très vite.");
      setForm({ full_name: "", email: "", phone: "", subject: "Demande générale", message: "" });
    } catch {
      toast.error("Erreur — réessayez ou écrivez-nous directement.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" data-testid="contact-section" className="section bg-ivory">
      <div className="container-max grid grid-cols-12 gap-12">
        <div className="col-span-12 md:col-span-5">
          <p className="overline">— Contact</p>
          <h2 className="font-display font-light text-5xl md:text-6xl leading-[0.95] tracking-tighter mt-6">
            Écrivons<br />
            les premiers <em className="italic text-terracotta">murs.</em>
          </h2>
          <div className="mt-12 space-y-6 text-ink">
            <a href="tel:+33184801234" data-testid="contact-phone-link" className="flex items-start gap-4 group">
              <Phone className="w-5 h-5 mt-1 text-terracotta" />
              <div>
                <p className="overline text-ink/50">Téléphone</p>
                <p className="font-display text-2xl mt-1 link-arc">01 84 80 12 34</p>
              </div>
            </a>
            <a href="mailto:atelier@maison-faubourg.fr" data-testid="contact-email-link" className="flex items-start gap-4">
              <Mail className="w-5 h-5 mt-1 text-terracotta" />
              <div>
                <p className="overline text-ink/50">Email</p>
                <p className="font-display text-2xl mt-1 link-arc">atelier@maison-faubourg.fr</p>
              </div>
            </a>
            <div className="flex items-start gap-4">
              <MapPin className="w-5 h-5 mt-1 text-terracotta" />
              <div>
                <p className="overline text-ink/50">Atelier</p>
                <p className="font-display text-2xl mt-1">27 rue du Faubourg<br />Saint-Honoré, 75008 Paris</p>
              </div>
            </div>
          </div>
        </div>

        <form onSubmit={submit} data-testid="contact-form" className="col-span-12 md:col-span-7 bg-bone p-8 md:p-12 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="overline">Nom complet*</label>
              <input data-testid="contact-name" required type="text" value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} className="input-sharp" />
            </div>
            <div>
              <label className="overline">Email*</label>
              <input data-testid="contact-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="input-sharp" />
            </div>
            <div>
              <label className="overline">Téléphone</label>
              <input data-testid="contact-phone" type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="input-sharp" />
            </div>
            <div>
              <label className="overline">Objet</label>
              <input data-testid="contact-subject" type="text" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="input-sharp" />
            </div>
          </div>
          <div>
            <label className="overline">Message*</label>
            <textarea data-testid="contact-message" required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="input-sharp resize-none" />
          </div>
          <div className="flex items-center justify-between flex-wrap gap-4">
            <p className="text-xs text-ink/50 max-w-sm">En envoyant ce formulaire, vous acceptez d'être recontacté par MAISON FAUBOURG. Données strictement confidentielles.</p>
            <button data-testid="contact-submit" type="submit" disabled={loading} className="btn-sharp">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Envoyer"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
